// function triggerFrontContentInView() {
//   function init() {
//     let observer = new IntersectionObserver((entries) => {
//       if (entries[0].intersectionRatio > 0) {
//         document.body.classList.add("hide-menu");
//       } else {
//         document.body.classList.remove("hide-menu");
//       }
//     });
//     observer.observe(document.querySelector(".front-header"));
//   }

//   const isPresent = document.getElementsByClassName("front-header");
//   if (isPresent.length > 0) {
//     init();
//   }
// }

// export { triggerFrontContentInView };

function triggerHeaderOutOfView() {
  function init() {
    const content = document.querySelector(".js-menu-control");

    let marginValues;

    marginValues = "0px 0px 0px 0px";

    const config = {
      rootMargin: marginValues,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio === 0) {
          document.body.classList.add("show-menu");
        } else {
          document.body.classList.remove("show-menu");
        }
      });
    }, config);

    observer.observe(content);
  }

  const isPresent = document.getElementsByClassName("js-menu-control");
  if (isPresent.length > 0) {
    init();
  }
}

export { triggerHeaderOutOfView };
